import request from '@/config/axios'

// 方案协助 VO（客户协同）
export interface PlanAssistVO {
  id: number // 编号
  customerId: number // 客户编号
  customerName?: string // 客户名称
  projectName: string // 项目名称
  salesUserId: number // 销售（用户编号）
  salesUserName?: string // 销售名字
  ownerUserId: number // 负责人（用户编号）
  ownerUserName?: string // 负责人名字
  planUserId: number // 方案负责人（用户编号）
  planUserName?: string // 方案负责人名字
  quoteUserId: number // 报价负责人（用户编号）
  quoteUserName?: string // 报价负责人名字
  participantUserIds: number[] // 参与人员（用户编号数组）
  participantUserNames?: string // 参与人员名字，顿号分隔
  knowerUserIds: number[] // 知晓人（用户编号数组）
  knowerUserNames?: string // 知晓人名字，顿号分隔
  ccUserIds: number[] // 抄送员（用户编号数组）
  ccUserNames?: string // 抄送员名字，顿号分隔
  status: number // 完成状态（字典 crm_plan_assist_status）
  assistDesc: string // 协同说明
  planDesc: string // 方案说明
  prepare: string // 需要准备
  remark: string // 备注
  followReply: string // 跟进回复
  fileUrls: string[] // 相关文件
  creator?: string
  creatorName?: string
  createTime?: Date
}

// 方案协助 API
export const PlanAssistApi = {
  // 查询方案协助分页
  getPlanAssistPage: async (params: any) => {
    return await request.get({ url: `/crm/plan-assist/page`, params })
  },

  // 查询方案协助详情
  getPlanAssist: async (id: number) => {
    return await request.get({ url: `/crm/plan-assist/get?id=` + id })
  },

  // 新增方案协助
  createPlanAssist: async (data: PlanAssistVO) => {
    return await request.post({ url: `/crm/plan-assist/create`, data })
  },

  // 修改方案协助
  updatePlanAssist: async (data: PlanAssistVO) => {
    return await request.put({ url: `/crm/plan-assist/update`, data })
  },

  // 删除方案协助
  deletePlanAssist: async (id: number) => {
    return await request.delete({ url: `/crm/plan-assist/delete?id=` + id })
  },

  // 导出方案协助
  exportPlanAssist: async (params: any) => {
    return await request.download({ url: `/crm/plan-assist/export`, params })
  }
}
